import { defineSchema } from "./defineSchema";

export const xRow = defineSchema({
  tableName: "users",
  columns: {
    id: {
      type: "string",
      isPrimaryKey: true,
    },
    creator: {
      type: "string",
      isForeignKeyOf: "users",
    },
    _date: {
      type: "string", 
      isArray: true,
    },
    _modifiedDate: {
      type: "string",
      isArray: true,
    },
  } as const,
});


export const xCreator = defineSchema({
  tableName: "users",
  columns: {
    ...xRow.columns,

    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    sex: {
      type: "string",
    },
    email: {
      type: "string",
    },
    address: {
      type: "string",
    },
    token: {
      type: "string",
    },
    lastTokenDate: {
      type: "string",
    },
    phoneNumber: {
      type: "string",
    },
    password: {
      type: "string",
    },
    profilePic: {
      type: "string",
      isNullable: true,
      // isForeignKeyOf: "uploads",
    },
    grade: {
      type: "string",
    },
    lastOnlineDate: {
      type: "string",
    },
    patientId: {
      type: "string",
    },
    role: {
      type: "string",
      // isForeignKeyOf: "roles",
    },
    workingPlan: {
      type: "string",
      // isForeignKeyOf: "workingPlans",
    },
    speciality: {
      type: "string",
      // isForeignKeyOf: "specialities",
    },
    service: {
      type: "string",
      // isForeignKeyOf: "services",
    },
    permissions: {
      type: "string",
      isArray: true,
    },
    interdictions: {
      type: "string",
      isArray: true,
    },
    appointmentTypes: {
      type: "string",
      isArray: true,
      // isForeignKeyOf: "appointmentTypes",
    },

    canValidateTypes: {
      type: "string",
      isArray: true,
      // isForeignKeyOf: "appointmentTypes",
    },
    canScheduleTypes: {
      type: "string",
      isArray: true,
      // isForeignKeyOf: "appointmentTypes",
    },
    remedLicence: {
      type: "string",
    },
    isValidated: {
      type: "boolean",
    },
    favouriteCalendars: {
      type: "string",
      isArray: true,
      // isForeignKeyOf: "users",
    },
    preferredBox: {
      type: "string",
      isNullable: true,
      // isForeignKeyOf: "boxes",
    },
    structureUnit: {
      type: "string",
      isNullable: true,
      // isForeignKeyOf: "units",
    },
  },
} as const);
